module.exports = __webpack_public_path__ + "img/bullet_4.c5f1d782.svg";